import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import './AbstractConfirmation.scss';
import { Button, EButtonType } from '@repo/apg-ui';

interface Props {
  onClose?: any;
  onSuccess: any;
  content: ReactNode;
  intl: any;
  isSuccessButtonLoading?: boolean;
}

const ConfirmationModal = ({ onClose, content, onSuccess, isSuccessButtonLoading }: Props) => {
  return (
    <div className='abstract-confirmatiom-modal' id='root'>
      <div className='close-modal'>
        <Button onClick={onClose}>
          <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
          <RedxIcon />
        </Button>
      </div>
      {content}
      <div className={'m-4 d-flex justify-content-between'}>
        <Button onClick={onClose} buttonType={EButtonType.InvertedPillMedium}>
          <FormattedMessage id='ec.confirmation.no' defaultMessage='Nein' />
        </Button>
        <Button onClick={onSuccess} buttonType={EButtonType.PillMedium} isLoading={isSuccessButtonLoading}>
          <FormattedMessage id='ec.confirmation.yes' defaultMessage='Ja' />
        </Button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
